/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Link, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import Cookies from 'universal-cookie'
import $ from 'jquery'

let Item = () => {
  let menuObj = []
  // let dropdownCount = 0;
  const [listItems, setListItem] = useState([
    { menu_name: '', sub: [], menu_link: '', menu_page: '' }
  ])
  const [show, setShow] = useState([])
  const cookies = new Cookies()
  const location = useLocation()
  /* if (location.state != null){
         const accessToken = location.state.access_token;
         const authToken = location.state.auth_token;
         const refreshToken = location.state.auth_refresh_token;
         console.log("in header" + accessToken);
         if (accessToken != null){
             cookies.set('auth_access_token',accessToken, { path: '/' });
             cookies.set('auth_token',authToken, { path: '/' });
             cookies.set('auth_refresh_token',refreshToken, { path: '/' });
         }
     }*/
  //     cookies.remove("access_token", { path: '/' });
  //   cookies.remove("auth_token", { path: '/' });
  //   cookies.remove("auth_refresh_token", { path: '/' });
  //   cookies.remove("userInfo", { path: '/' });
  const [userName, setUserName] = useState('')
  //  if (cookies.get("userInfo")!=null)
  //      setUserName(cookies.get("userInfo").userName);
  const showDropdown = index => {
    setShow(show => show.map((item, key) => (key === index ? true : item)))
  }
  const hideDropdown = index => {
    setShow(show => show.map((item, key) => (key === index ? false : item)))
  }
  useEffect(() => {
    var navbar_visible = $('#basic-navbar-nav').is(':visible')
    if (navbar_visible) {
      $('.navbar-toggler').trigger('click')
    }

    $('.opemenu').click(function () {
      if ($(this).hasClass('active')) {
        $('#menu').slideToggle()
        $(this).removeClass('active')
      } else {
        $('#menu').slideToggle()
        $(this).addClass('active')
      }
    })

    let accessToken = cookies.get('auth_access_token')
    let userInfo = cookies.get('userInfo')
    if (accessToken != null && accessToken !== '') {
    //   let apiUrl = ''
      let apiUrl = process.env.REACT_APP_LOGIN_API
      let apiParams = {}
    //   apiUrl = '/Login/UserInfo'
      apiParams = {
        access_token: accessToken
      }
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(apiParams)
      }

      // cookie如果存在user會員資料即不再撈取資料
      if (cookies.get('userInfo') == null) {
        // fetch('/api' + apiUrl, requestOptions)
        fetch(apiUrl, requestOptions)
          .then(res => res.json())
          .then(result => {
            setUserName(result.result.userName)
            cookies.set(
              'userInfo',
              {
                userName: result.result.userName,
                userEmail: result.result.userEmail,
                userPhone: result.result.userPhone,
                userExtraData: result.result.userExtraData,
                chtSn: result.result.chtSn
              },
              { path: '/' }
            )
          })
          .catch(err => {
            throw new Error(err)
          })
      }
    }
  }, [location])
  useEffect(() => {
    // fetch("/apt/header/")
    fetch(process.env.REACT_APP_HEADER_API)
      .then(res => res.json())
      .then(result => {
        // result = result;
        // 產生header menu(包含下拉選單)資料
        for (var i = 0; i < result.length; i++) {
          if (i > 0) {
            if (result[i].menu_type !== result[i - 1].menu_type) {
              result[i].sub = []
              menuObj.push(result[i])
            } else {
              var subMenu = []
              subMenu = menuObj[menuObj.length - 1].sub
              subMenu.push(result[i])
            }
          } else {
            result[i].sub = []
            menuObj.push(result[i])
          }
        }

        let counter = 0
        for (var k = 0; k < menuObj.length; k++) {
          if (menuObj[k].sub.length !== 0) {
            menuObj[k].dropDownCounter = counter
            show[counter] = false // 判斷menu是否打開
            counter++
          }
        }

        // setShow(show);
        setListItem(menuObj)
      })
      .catch(err => {
        throw new Error(err)
      })
  }, [])

  return (
    <>
      {/* <BrowserRouter> */}
      <Navbar expand='lg'>
        <Navbar.Brand href='/'>
          <img
            src={require('./image/logo_header.png').default}
            width='300'
            className='d-inline-block align-top logo'
            alt='React Bootstrap logo'
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='me-auto'>
            {listItems.map((item, index) =>
              item.sub.length === 0 ? (
                <Nav.Link key={index} as={Link} to={item.menu_link}>
                  {' '}
                  {item.menu_name}{' '}
                </Nav.Link>
              ) : (
                <NavDropdown
                  key={index}
                  title={item.menu_name}
                  id='basic-nav-dropdown'
                  show={show[item.dropDownCounter]}
                  onMouseEnter={() => showDropdown(item.dropDownCounter)}
                  onMouseLeave={() => hideDropdown(item.dropDownCounter)}
                >
                  {item.sub.map((subItem, index2) => (
                    <NavDropdown.Item
                      key={index2}
                      href={
                        subItem.menu_link !== ''
                          ? subItem.menu_link
                          : subItem.menu_page
                      }
                    >
                      {subItem.menu_name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              )
            )}
            {listItems.length > 0 ? (
              <Nav.Link
                as={Link}
                to={
                  cookies.get('auth_access_token') != null
                    ? '/logout'
                    : '/login'
                }
              >
                {' '}
                {cookies.get('auth_access_token') != null
                  ? '登出'
                  : '登入'}{' '}
              </Nav.Link>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  )
}

let Header = () => {
  return (
    <header>
      <div className='pagesize'>
        <Item />
      </div>
    </header>
  )
}

export default Header